module.exports = __webpack_public_path__ + "img/logo_gray.840ce9d1.jpg";